
import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-serif">
                About <span className="text-yellow-600 italic">Glory Odudu</span>
              </h2>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Glory Odudu is redefining what it means to build wealth not by working harder, but by owning smarter.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                As an Investor, Speaker, and Business Acquisition Strategist, Glory empowers professionals and business owners to unlock freedom and legacy through business ownership.
              </p>
            </div>
            
            {/* Philosophy Quote */}
            <div className="bg-gray-50 p-8 rounded-lg border-l-4 border-yellow-600">
              <blockquote className="text-xl md:text-2xl font-serif italic text-gray-800 mb-4">
                "Ownership isn't just about money — it's about control. Control over your time, income, and future."
              </blockquote>
              <cite className="text-yellow-600 font-medium">— Glory Odudu</cite>
            </div>
            
            {/* Mission Statement */}
            <div className="bg-black p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-white mb-4 font-serif">Mission Statement</h3>
              <p className="text-lg text-gray-200 leading-relaxed">
                To empower a new generation of business owners who acquire freedom, not just titles.
              </p>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://static.readdy.ai/image/224dc00200a5f30b66b07d4513abc50a/57052844dea9c37bb879236dd901f6df.jpeg"
                alt="Glory Odudu - Business Acquisition Strategist"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-yellow-600 text-black p-6 rounded-lg shadow-lg">
              <div className="text-center">
                <div className="text-3xl font-bold">5+</div>
                <div className="text-sm font-medium">Years Experience</div>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 bg-black text-white p-6 rounded-lg shadow-lg">
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-600">$18M+</div>
                <div className="text-sm font-medium">Deals Facilitated</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
